/**
 * Base klasa dla komponentów FAQ
 * Zawiera podstawową logikę zarządzania stanem accordion/FAQ
 */
class Collapse {
    constructor() {
        this.openItems = [];
    }

    /**
     * Sprawdza czy element jest otwarty
     * @param {string} id - ID elementu
     * @returns {boolean}
     */
    isOpen(id) {
        return this.openItems.includes(id);
    }

    /**
     * Przełącza stan elementu (otwiera/zamyka)
     * @param {string} id - ID elementu
     */
    toggle(id) {
        this.isOpen(id) ? this.close(id) : this.open(id);
    }

    /**
     * Otwiera element
     * @param {string} id - ID elementu
     */
    open(id) {
        if (!this.openItems.includes(id)) {
            this.openItems.push(id);
        }
    }

    /**
     * Zamyka element
     * @param {string} id - ID elementu
     */
    close(id) {
        this.openItems = this.openItems.filter((item) => item !== id);
    }

    /**
     * Zamyka wszystkie elementy
     */
    closeAll() {
        this.openItems = [];
    }
}

export { Collapse };
